import { render, staticRenderFns } from "./app-banners.vue?vue&type=template&id=79e8d35b&"
import script from "./app-banners.vue?vue&type=script&lang=ts&"
export * from "./app-banners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports